import type { FilterPanelAddButtonProps } from "./types-add-button";
import { useFilterPanelAddButton } from "./use-add-button";
import { FilterPanelAddButtonView } from "./view-add-button";

export function FilterPanelAddButton(props: FilterPanelAddButtonProps) {
  const viewModel = useFilterPanelAddButton(props);

  return <FilterPanelAddButtonView {...viewModel} />;
}
FilterPanelAddButton.displayName = "FilterPanel.AddButton";
